// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\r\n/* Make sure container takes full size */\ndiv[ref=\"mapRoot\"][data-v-351ad99d] {\r\n  width: 100%;\r\n  height: 100%;\n}\r\n\r\n", ""]);
// Exports
module.exports = exports;
